import { Link } from '@/lib/router'
import { SiteShell } from '@/components/site/site-shell'
import {
  PET_DEMO_IDS,
  petDemoPagePath,
  petDemoThumbPath,
} from '@/constants/petDemos'

export default function PetsDemoGallery() {
  return (
    <SiteShell>
      <div className="pt-20" />
      <section className="mx-auto max-w-6xl px-4 pb-24 md:px-6">
        <header className="mb-10 max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
            Demo gallery
          </p>
          <h1 className="mt-2 font-serif text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            Pets
          </h1>
          <p className="mt-3 text-muted-foreground leading-relaxed">
            WordPress pet-theme previews. Click a thumbnail to open the full screenshot in a new
            tab.
          </p>
        </header>

        <ul className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-5">
          {PET_DEMO_IDS.map((id) => (
            <li key={id}>
              <Link
                to={petDemoPagePath(id)}
                target="_blank"
                rel="noopener noreferrer"
                className="group block overflow-hidden rounded-lg border border-border bg-card shadow-sm transition-shadow hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <div className="overflow-hidden bg-muted">
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src={petDemoThumbPath(id)}
                    alt={`Pets demo ${id}`}
                    className="block h-auto w-full transition-transform duration-300 group-hover:scale-[1.01]"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <p className="border-t border-border px-3 py-2 text-center text-sm font-medium tabular-nums text-foreground">
                  {id}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </SiteShell>
  )
}
